import React from 'react';

// Material-UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import {
  HouseholdRequestStatus
} from '../../models';

// Date formatting
import { useDates } from '../../hooks/UseDates';

interface WeekendHolidayProps {
  postDeadlineAvailable: boolean;
  requestStatus: HouseholdRequestStatus;
}

const WeekendHoliday: React.FC<WeekendHolidayProps> = (props) => {

  const { dateStringToLocalDateFormatted } = useDates();

  // #region Styles

  const theme = useTheme();
  const styles = {
    activeRequestsContainer: {
      margin: theme.spacing(1, 0, 1, 0),
    },
    postDeadlineContainer: {
      margin: theme.spacing(0, 0, 0, 0)
    },
  };

  // #endregion

  return (
    <>
      {(props.requestStatus.requests.length === 0) &&
        <Grid container>
          <Grid container>
            <Typography variant="button">{`Active Weekend/Holiday Requests`}</Typography>
          </Grid>
          <Grid container>
            <Typography variant="caption" paragraph>No weekend/holiday requests have been submitted.</Typography>
          </Grid>
        </Grid>
      }
      {(props.requestStatus.requests.length > 0) &&
        <Grid container sx={styles.activeRequestsContainer}>
          <Grid container>
            <Typography variant="button">{`Weekend/Holiday Active Requests: ${props.requestStatus.requests.length}/${props.requestStatus.maxRequests} Permitted`}</Typography>
          </Grid>
          {props.requestStatus.requests.map(r => (
            <Grid container spacing={2} key={r.signupID}>
              <Grid size={2}>
                <Typography variant="caption">{`#${r.referenceNumber}`}</Typography>
              </Grid>
              <Grid size={6}>
                <Typography variant="caption">{`${r.minArrivalDate}-${r.maxDepartureDate}`}</Typography>
              </Grid>
              <Grid>
                <Typography variant="caption">{`${r.priorityPeriods} Weekend/Holiday`}</Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      }
      {(props.requestStatus.requestCount === props.requestStatus.maxRequests) &&
        <Grid container>
          <Typography variant="caption" paragraph>A new weekend request will be available after completing a lodge stay, cancelling a priority requests, or being "bumped".</Typography>
        </Grid>
      }
      {props.postDeadlineAvailable &&
        <Grid container sx={styles.postDeadlineContainer}>
          <Typography variant="caption"><b>{`${dateStringToLocalDateFormatted(props.requestStatus.postDeadline.arrivalDate, 'M/d/yyyy')}-${dateStringToLocalDateFormatted(props.requestStatus.postDeadline.departureDate, 'M/d/yyyy')} Weekend/Holiday Post Deadline`}</b></Typography>
          <Typography variant="caption">{`Requests available first come, first served, and will not count towards the active request limit (Select dates manually).`}</Typography>
        </Grid>
      }
    </>
  );
}

export default WeekendHoliday;